module.exports = __webpack_public_path__ + "img/cl-install-hp-mac_12200.d4e94712.png";